<template>
  <div class="resources container">
    <div class="row">
      <div class="col">
      <PageHeading heading="Resources"/>
      <table class="table table-striped">
        <thead><tr><th>Resource</th><th>Download</th></tr></thead>
        <tbody>
        
        <tr><td>Memory Sheet for Luke</td><td><a href="/wapac/downloads/resources/MemorySheetLuke.pdf">PDF</a></td></tr>
        <tr><td>Memory Verses (Four Column)</td><td><a href="/wapac/downloads/resources/MemoryVerses.pdf">PDF</a></td></tr>
        <tr><td>Unique Words List</td><td><a href="/wapac/downloads/resources/UniqueWords.pdf">PDF</a></td></tr>
        <tr><td>Two-Team Scoresheet</td><td><a href="/wapac/downloads/resources/2Team.pdf">PDF</a></td></tr>
        <tr><td>Three-Team Schoresheet</td><td><a href="/wapac/downloads/resources/3Team.pdf">PDF</a></td></tr>
        <tr><td>Two Two-Team Scoresheet</td><td><a href="/wapac/downloads/resources/ScoreSheet2Team2perPage.pdf">PDF</a></td></tr>
        <tr><td>Team Lineup's</td><td><a href="/wapac/downloads/resources/team_lineup.pdf">PDF</a></td></tr>
        </tbody>
      </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeading from '@/components/PageHeading.vue';

export default {
  name: 'Resources',
  components: {
    PageHeading
  }
}
</script>

<style scoped>

</style>